import moment from 'moment'

const timeStampNow = (value) => {
  return value ? moment(value).locale('pt-br').fromNow() : ''
}

export default timeStampNow
